:host {
  display: block;
  pointer-events: none;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.trigger-container {
  position: fixed;
  top: calc(50% - 24px);
  right: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  z-index: 2147480000;
}

.trigger-button {
  width: 48px;
  height: 48px;
  border: none;
  padding: 0;
  margin: 0;
  border-radius: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.trigger-button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 2px;
}

.trigger-button:hover {
  transform: scale(1.02);
}

.trigger-icon {
  display: inline-flex;
  width: 24px;
  height: 24px;
}

.trigger-icon svg {
  width: 100%;
  height: 100%;
  display: block;
}

.tooltip {
  position: absolute;
  right: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%) scale(0.95);
  transform-origin: right center;
  padding: 6px 10px;
  background-color: rgba(0, 0, 0, 0.85);
  color: #ffffff;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease, transform 0.15s ease;
  max-width: 200px;
}

.trigger-button:hover + .tooltip,
.trigger-button:focus + .tooltip,
.trigger-container:hover .tooltip {
  opacity: 1;
  transform: translateY(-50%) scale(1);
}

.dialog-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 2147480001;
}

.dialog {
  position: relative;
  width: min(92vw, 480px);
  max-height: min(86vh, 720px);
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

.close-button {
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(15, 23, 42, 0.08);
  color: #111827;
  font-size: 24px;
  line-height: 1;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.close-button:hover {
  background: rgba(15, 23, 42, 0.14);
  transform: scale(1.02);
}

.close-button:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px 12px;
}

.dialog-header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-pill {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #4338ca;
  font-weight: 600;
}

.dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
}

.dialog-subtitle {
  margin: 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.4;
}

.dialog-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
  flex: 1;
  min-height: 0;
}

.message-container {
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  padding: 16px;
  background: #f8fafc;
  flex: 1;
  min-height: 240px;
  max-height: 420px;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.message-container::-webkit-scrollbar {
  width: 6px;
}

.message-container::-webkit-scrollbar-thumb {
  background-color: rgba(100, 116, 139, 0.4);
  border-radius: 999px;
}

.message-row {
  display: flex;
  margin-bottom: 12px;
}

.message-row:last-child {
  margin-bottom: 0;
}

.message-row-user {
  justify-content: flex-end;
}

.message-row-assistant {
  justify-content: flex-start;
}

.message-bubble {
  max-width: 85%;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 1.45;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
  white-space: pre-wrap;
}

.message-bubble-user {
  background: #4338ca;
  color: #ffffff;
  border-bottom-right-radius: 2px;
}

.message-bubble-assistant {
  background: #ffffff;
  color: #0f172a;
  border-bottom-left-radius: 2px;
}

.message-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
}

.typing-indicator {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.typing-indicator span {
  width: 6px;
  height: 6px;
  background-color: #6366f1;
  border-radius: 50%;
  animation: typing 1.2s infinite ease-in-out;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.15s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes typing {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.6;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.empty-conversation {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
  color: #475569;
  padding: 48px 24px;
}

.empty-conversation-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.empty-conversation-subtitle {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.error-banner {
  margin-top: 12px;
  padding: 12px;
  border-radius: 10px;
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
  font-size: 13px;
}

.product-carousel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.product-carousel-track {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(160px, 1fr);
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.product-carousel-track::-webkit-scrollbar {
  height: 6px;
}

.product-carousel-track::-webkit-scrollbar-thumb {
  background-color: rgba(100, 116, 139, 0.3);
  border-radius: 999px;
}

.product-card {
  background: #f1f5f9;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.25);
  display: flex;
  flex-direction: column;
  min-height: 200px;
}

.product-image-wrapper {
  position: relative;
  padding-top: 75%;
  background: linear-gradient(135deg, #eef2ff, #e0f2fe);
}

.product-image-wrapper img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-card-body {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-card-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
}

.product-card-price {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #4338ca;
}

.product-card-link {
  margin-top: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  text-decoration: none;
}

.product-card-link:hover,
.product-card-link:focus {
  text-decoration: underline;
}

.prompt-form {
  display: flex;
  gap: 12px;
  padding: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  border-radius: 14px;
  background: #ffffff;
  align-items: flex-end;
}

.prompt-textarea {
  flex: 1;
  resize: none;
  border: none;
  font-size: 14px;
  line-height: 1.5;
  color: #0f172a;
  font-family: inherit;
  min-height: 24px;
  max-height: 160px;
  background: transparent;
}

.prompt-textarea::placeholder {
  color: #94a3b8;
}

.prompt-textarea:focus {
  outline: none;
}

.prompt-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prompt-submit {
  border: none;
  border-radius: 999px;
  padding: 10px 18px;
  background: #4338ca;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.prompt-submit:hover:not(:disabled) {
  background: #3730a3;
  transform: translateY(-1px);
}

.prompt-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prompt-submit:focus-visible {
  outline: 2px solid rgba(67, 56, 202, 0.35);
  outline-offset: 2px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@media (max-width: 640px) {
  .dialog {
    width: min(96vw, 420px);
    max-height: 92vh;
  }

  .dialog-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .close-button {
    align-self: flex-end;
  }

  .message-container {
    max-height: 360px;
  }
}
